import { poly, make, type MapDoor, type MapPoly, type MapRoof } from '../geom.ts';
import { gridMap } from '../mapgrid.ts';
import { withGeometry } from '../mapgeo.ts';
import { PIECES, RADAR, TANKS } from './airbasedata.ts';
import { cargoPlane, fighterJet, helicopter, lShape, roundTank, truck, place } from '../shapes.ts';

/** Kestrel Field (see airbasedata.ts for the lore). The west half is drawn here; withGeometry adds the half-turn twin of every poly, door and roof. W,E,J,x,L,I,O,j are the Airbase's wall letters. */
const WEST = `
  ############################################################
  #...........................................................
  #.............................FF............................
  #...........................................................
  #...EEEEEEEEEEEEEEEEEEEEE..EEEEEEEEEEEEEEEEEEEEE............
  #...E...........J............LLLLLLL...........E............
  #...E.II........J.................c.........FF.E............
  #...E.......................................FF.E............
  #...E..........................................E..FF........
  #...E...........J.................................FF........
  #...E...........J...........................................
  #...E...........J...........................................
  #...E..i......m.J...........................................
  #...EJJJJ..JJJJJJ.....FF....................................
  #...E.................FF.......................E....l.......
  #...E..........................................E............
  #...E..........................................E............
  #...E.FF.......................................E............
  #...E.FF.......................................E............
  #...E..........................................E.FF.........
  #...E..........................................E.FF.........
  #...E..........................................E...........b
  #...E..........................................E............
  #..............................................E..........a.
  #.........A....................................E............
  #...E..........................................E...c.......c
  #.l.E..........................................E............
  #...E..........................................E............
  #...E..........................................E............
  #...E..........................................E............
  #...E.........c...............................eE............
  #...E..........................................E............
  #...E..........................................E............
  #...E..........................................E............
  #...E..........................................E...........l
  #...EJJJJ..JJJJJ............................................
  #...E..........J............................................
  #...E.OO....OO.J............................................
  #...E.OO.......J............................................
  #...E.......................................................
  #...E.......b..................................E............
  #...E..........J............................FF.E............
  #...E..g.......J......c.....................FF.E............
  #...E..........J...LLLLLLL.....................E............
  #...EEEEEEE..EEEEEEEEEEEEEEEEEEEEEE..EEEEEEEEEEE............
  #...........................................................
  #.....FF....................................................
  #...........................................................
  #..........................................l................
  #....JJJJJJJ................................................
  #....J.....J......EEEEEEEEEEEE..EEEEEEEEEEEEEE..............
  #....J............E.LLLLLLL..............LL..E...jj.........
  #....J............E................FF........E..............
  #....J.....J......E...c..g.........FF........E..............
  #....JJJ..JJ......E........................i.E..l...........
  #.................E..........................E....e.........
  #.............jj..E..........................E..............
  #.................E..........................E.JJJJJJ.......
  #..c..........l................................J............
  #...........................................................
  #...........................................................
  #...........................................b..J.m..........
  #.................E..........................E.JJJJJJ.......
  #.................E..........................E..............
  #.................E..........................E..............
  #................bE..........................E..............
  #.................E.....................o....E..............
  #.................E.......................OOOE..............
  #.....RRRRRRR.....E...LLLLLL..............OOOE..............
  #.....RRRRRRR.....EEEEEEEEEEEE..EEEEEEEEEEEEEE..............
  #.....RRRRRRR.......................................c.......
  #.....RRRRRRR...............................................
  #.....RRRRRRR.......FF.......l..............................
  #.....RRRRRRR.......FF...........FF.........................
  #.l..............................FF.........................
  #........FF.................................................
  #...................c.......................................
  #...........................................................
  #....JJJJJJJJJJJJJJJJJJJJJJ..JJJJJ....JJJJJJJJJ...l.........
  #....JI....IJI....IJI....IJ..J................J.............
  #.FF.JI....IJI....IJI....IJ..J................J.............
  #....JI....IJI....IJI....IJ..J..IIIIIIIIIIII..J.............
  #....J......J......J......J.................................
  #....J......J......J......J.................................
  #....J......J......J......J..J..IIIIIIIIIIII..J.............
  #....J......J......J......J..J................J.............
  #....JJJ..JJJJJ..JJJJJ..JJJ..J..IIIIIIIIIIII..J.............
  #............................J................J.............
  #..m.........................JJJJJJ....JJJJJJJJ...b.........
  #....JJJ..JJJJJ..JJJJJ..JJJ..J................J.............
  #....JI.....JI.....JI.....J..JLLLL........LLLLJ.............
  #....JI.....JI.....JI.....J..J................J.............
  #..c.JI.....JI.....JI.....J..J.....p..........J..c..........
  #....J......J......J......J..J................J.............
  #....J.....IJ.....IJ.....IJ..JLLLL............J.............
  #....J.....IJ.....IJ.....IJ..JJJJJJJJJJJJJJ..JJ.............
  #....JJJJJJIJJJJJJIJJJJJJIJ.....................o...........
  #...........................................................
  #...............................................c...........
  #...........................................................
  #....JJJJJJJJJJJJJJJJJJJJJJ.........FF...FF...l.............
  #....JI....I.JI....IJ.....J.........FF...FF.................
  #....JI....I.JI....IJ..II.J..l..............................
  #....JI....I.JI....IJ.....J.................................
  #....J.......J......J.....J......c..........................
  #....J.......J......J.....J.................................
  #....J.......J......J.....J...FF............................
  #....J.......J......J.....J...FF...........................b
  #....JJJ..JJJJJ..JJJJJ..JJJ............JJ..JJJ..FF..........
  #...................a...........jj.....J.....J..FF..........
  #......................................J.....J..............
  #....JJJJJJJJJJJJJJJJJJJJJJ............J.....J..............
  #......................................J....aJ..............
  #......................................JJJJJJJ...l..........
  #...........................................................
  #...............................................jjJ..JJ.....
  #.................................................J..pJ..jj.
  #.................................................JJJJJ.....
  #...........................................................
  ############################################################
`;

const POLYS: MapPoly[] = [
  ...place(cargoPlane, PIECES.plane, 'airframe', { id: 'c130' }),
  ...place(fighterJet, PIECES.jet, 'airframe', { id: 'jet' }),
  ...place(helicopter, PIECES.heli, 'airframe', { id: 'heli' }),
  make(poly.circle(RADAR.x, RADAR.y, RADAR.r, 16), 'dome', { id: 'radar', height: 64 }),
  ...place(roundTank, { x: TANKS[0].x, y: TANKS[0].y, scale: 0.55 }, 'tank', { id: 'tank1' }),
  ...place(roundTank, { x: TANKS[1].x, y: TANKS[1].y, scale: 0.55 }, 'tank', { id: 'tank2' }),
  ...place(roundTank, { x: TANKS[2].x, y: TANKS[2].y, scale: 0.55 }, 'tank', { id: 'tank3' }),
  ...place(truck, PIECES.bowser, 'vehicle', { id: 'bowser' }),
  make(poly.transform(poly.rect(-140, -18, 280, 36), { x: 2590, y: 1500, rot: 0.55 }), 'fence', { id: 'jbd1', height: 46 }),
  make(poly.transform(poly.rect(-140, -18, 280, 36), { x: 2860, y: 1560, rot: -0.55 }), 'fence', { id: 'jbd2', height: 46 }),
  ...place(truck, PIECES.bowser2, 'vehicle', { id: 'bowser2' }),
  make(poly.transform(poly.rect(-95, -50, 190, 100), { x: 2900, y: 2300, rot: 0 }), 'vehicle', { id: 'tug', height: 30 }),
  make(poly.transform(poly.rect(-75, -45, 150, 90), { x: 2740, y: 2300, rot: 0 }), 'cart', { id: 'cart1', height: 22 }),
  make(poly.transform(poly.rect(-75, -45, 150, 90), { x: 2600, y: 2300, rot: 0 }), 'cart', { id: 'cart2', height: 22 }),
  ...place(truck, PIECES.crash, 'vehicle', { id: 'crash' }),
  ...place(lShape, { x: 2440, y: 2430, scale: 0.3, rot: 0 }, 'sbags', { id: 'rev1' }),
  make(poly.circle(760, 2640, 26, 8), 'mast', { id: 'mast', height: 80 }),
  make(poly.circle(1875, 5320, 22, 8), 'pole', { id: 'flagpole', height: 90 }),
  make(poly.arc(3000, 3000, 330, 380, Math.PI + 0.2, Math.PI * 1.5 - 0.2, 8), 'ring', { id: 'ring-nw', height: 72 }),
  make(poly.arc(3000, 3000, 330, 380, Math.PI * 0.5 + 0.2, Math.PI - 0.2, 8), 'ring', { id: 'ring-sw', height: 72 }),
];
const DOORS: MapDoor[] = [
  { id: 'h1-door-n', kind: 'double-slide', x: 2375, y: 450, w: 250, axis: 'v', material: 'metal', glow: '#cfe3ff' },
  { id: 'h1-door-s', kind: 'double-slide', x: 2375, y: 1750, w: 250, axis: 'v', material: 'metal', glow: '#cfe3ff' },
  { id: 'h1-ps1', kind: 'swing', x: 550, y: 2225, w: 100, axis: 'h', material: 'wood' },
  { id: 'h1-ps2', kind: 'swing', x: 1750, y: 2225, w: 100, axis: 'h', material: 'wood' },
  { id: 'h1-pw', kind: 'swing', x: 225, y: 1150, w: 100, axis: 'v', material: 'wood' },
  { id: 'h1-pn', kind: 'swing', x: 1250, y: 225, w: 100, axis: 'h', material: 'wood' },
  { id: 'crib-s', kind: 'swing', x: 450, y: 675, w: 100, axis: 'h', material: 'wood' },
  { id: 'crib-e', kind: 'swing', x: 825, y: 350, w: 100, axis: 'v', material: 'wood' },
  { id: 'cage-e', kind: 'swing', x: 775, y: 1950, w: 100, axis: 'v', material: 'wood' },
  { id: 'mb-e', kind: 'double-slide', x: 2275, y: 2900, w: 200, axis: 'v', material: 'metal', glow: '#d6ffb0' },
  { id: 'mb-w', kind: 'double-swing', x: 925, y: 2900, w: 200, axis: 'v', material: 'wood' },
  { id: 'mb-n', kind: 'swing', x: 1500, y: 2525, w: 100, axis: 'h', material: 'wood' },
  { id: 'mb-s', kind: 'swing', x: 1500, y: 3475, w: 100, axis: 'h', material: 'wood' },
  { id: 'comms-s', kind: 'swing', x: 400, y: 2725, w: 100, axis: 'h', material: 'wood' },
  { id: 'comms-e', kind: 'swing', x: 575, y: 2550, w: 100, axis: 'v', material: 'wood' },
  { id: 'st-w', kind: 'swing', x: 2375, y: 2950, w: 100, axis: 'v', material: 'wood' },
  { id: 'ring-w', kind: 'swing', x: 2645, y: 2936, w: 128, axis: 'v', material: 'wood' },
  { id: 'ring-n', kind: 'swing', x: 2936, y: 2645, w: 128, axis: 'h', material: 'wood' },
  { id: 'bk-an0', kind: 'swing', x: 400, y: 4325, w: 100, axis: 'h', material: 'wood' },
  { id: 'bk-as0', kind: 'swing', x: 400, y: 4475, w: 100, axis: 'h', material: 'wood' },
  { id: 'bk-an1', kind: 'swing', x: 750, y: 4325, w: 100, axis: 'h', material: 'wood' },
  { id: 'bk-as1', kind: 'swing', x: 750, y: 4475, w: 100, axis: 'h', material: 'wood' },
  { id: 'bk-an2', kind: 'swing', x: 1100, y: 4325, w: 100, axis: 'h', material: 'wood' },
  { id: 'bk-as2', kind: 'swing', x: 1100, y: 4475, w: 100, axis: 'h', material: 'wood' },
  { id: 'bk-aw', kind: 'swing', x: 275, y: 4350, w: 100, axis: 'v', material: 'wood' },
  { id: 'bk-ae', kind: 'swing', x: 1325, y: 4350, w: 100, axis: 'v', material: 'wood' },
  { id: 'bk-b0', kind: 'swing', x: 400, y: 5425, w: 100, axis: 'h', material: 'wood' },
  { id: 'bk-b1', kind: 'swing', x: 750, y: 5425, w: 100, axis: 'h', material: 'wood' },
  { id: 'bk-b2', kind: 'swing', x: 1100, y: 5425, w: 100, axis: 'h', material: 'wood' },
  { id: 'bk-bw', kind: 'swing', x: 275, y: 5450, w: 100, axis: 'v', material: 'wood' },
  { id: 'bk-be', kind: 'swing', x: 1325, y: 5450, w: 100, axis: 'v', material: 'wood' },
  { id: 'mess-n', kind: 'double-swing', x: 1700, y: 3925, w: 200, axis: 'h', material: 'wood' },
  { id: 'mess-e', kind: 'swing', x: 2325, y: 4100, w: 100, axis: 'v', material: 'wood' },
  { id: 'mess-w', kind: 'swing', x: 1475, y: 4100, w: 100, axis: 'v', material: 'wood' },
  { id: 'mess-k', kind: 'double-swing', x: 1750, y: 4425, w: 200, axis: 'h', material: 'wood' },
  { id: 'mess-s', kind: 'swing', x: 2150, y: 4775, w: 100, axis: 'h', material: 'wood' },
  { id: 'arm-n', kind: 'swing', x: 2050, y: 5425, w: 100, axis: 'h', material: 'wood' },
  { id: 'gate-booth', kind: 'swing', x: 2550, y: 5775, w: 100, axis: 'h', material: 'wood' },
];
const ROOFS: MapRoof[] = [
  { id: 'crib', points: poly.rect(250, 250, 600, 450) },
  { id: 'cage', points: poly.rect(250, 1750, 550, 450) },
  { id: 'hangar1', points: poly.rect(200, 200, 2200, 2050) },
  { id: 'bay1', points: poly.rect(900, 2500, 1400, 1000) },
  { id: 'comms', points: poly.rect(250, 2450, 350, 300) },
  { id: 'stairs', points: poly.rect(2350, 2850, 300, 300) },
  { id: 'barracksA', points: poly.rect(250, 3900, 1100, 950) },
  { id: 'barracksB', points: poly.rect(250, 5000, 1100, 600) },
  { id: 'mess', points: poly.rect(1450, 3900, 900, 900) },
  { id: 'armoury', points: poly.rect(1950, 5400, 350, 300) },
  { id: 'booth', points: poly.rect(2500, 5750, 250, 150) },
];

export const AIRBASE = withGeometry(withGeometry(gridMap('Airbase', WEST, 'airbase'), { polys: POLYS, doors: DOORS, roofs: ROOFS }), { roofs: [{ id: 'tower', points: poly.circle(3000, 3000, 380, 36) }], twin: false });
